import { useMutation } from '@tanstack/react-query';

import { useQueryInvalidation } from '@pkg/hooks';

import { Competitions, type SingleTeamParams, type UpdateTeamParams } from '@app/client';
import { COMPETITION_TEAM_QUERIES, FANTASY_LEADERBOARD_CACHE } from '@app/client/resources/competitions';

export function useUpdateTeam() {
    const invalidateTeamQueries = useQueryInvalidation(COMPETITION_TEAM_QUERIES);

    return useMutation({
        mutationFn: ({ teamId, value }: UpdateTeamParams) => Competitions.callUpdateTeam({ teamId, value }),
        onSuccess: invalidateTeamQueries,
    });
}

export function useDeleteTeam() {
    const invalidateQueries = useQueryInvalidation([...COMPETITION_TEAM_QUERIES, ...FANTASY_LEADERBOARD_CACHE]);
    return useMutation({
        mutationFn: (teamId: SingleTeamParams) => Competitions.callDeleteTeam(teamId),
        onSuccess: () => {
            invalidateQueries();
        },
    });
}
